// extracted by mini-css-extract-plugin
export default {"error":"error404_error__aP1uo","errorContent":"error404_errorContent__fUxyF"};